const vibrate = (pattern) => {
  if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
    navigator.vibrate(pattern)
  }
}

export const haptics = {
  // Light tap for standard interactions (buttons, toggles)
  selection: () => {
    vibrate(10)
  },
  // Distinct bump for successful actions (completion, save)
  success: () => {
    vibrate(25)
  },
  // Double pulse for destructive actions or errors
  error: () => {
    vibrate([15, 30, 15])
  },
  // Very light tick for fine interactions (sliders, dragging)
  impact: () => {
    vibrate(5)
  },
}
